// Author SWL
// Date 2022-03-29 16:43:52

class EmArchToolType {
constructor({
        id = null,
        type = '',
        remark = ''}
= {}) {
    this.id = id;
    this.type = type;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchToolType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchToolType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'type',
        label: 'label.em.archive.emArchToolType.grid.type',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    typeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'typeFilter',
        label: 'label.em.archive.emArchToolType.filter.type',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'type',
        label: 'label.em.archive.emArchToolType.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmArchToolType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
